<template>
  <component
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    :class="{ active: isActive }"
    tag="li"
  >
    <a
      v-if="isMenu"
      href="#"
      class="nav-link sidebarMenuItem"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click.prevent="collapseMenu"
    >
      <template v-if="link.icon_type === 'fontawesome'">
        <i
          class="md-icon md-theme-default md-icon-font"
          :class="`${link.icon}`"
        ></i>
      </template>
      <template v-else>
        <md-icon class="sidebar-menu-logo">{{ link.icon }}</md-icon>
      </template>
      <p>
        {{ link.name }}
        <b class="caret"></b>
      </p>
    </a>

    <collapse-transition>
      <div v-if="$slots.default || this.isMenu" v-show="!collapsed">
        <ul class="nav">
          <slot></slot>
        </ul>
      </div>
    </collapse-transition>

    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path"
    >
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        :class="[
          { active: link.active },
          { sidebarMenuItemNoChild: !addLink },
          { sidebarMenuSubItem: addLink }
        ]"
        class="nav-link"
        :target="link.target"
        :href="link.path"
      >
        <template v-if="addLink">
          <!-- <span class="sidebar-mini">{{ linkPrefix }}</span> -->
          <i
            v-if="link.icon_type === 'fontawesome'"
            class="side-bar-fas-sub-item"
            :class="`${link.icon}`"
          ></i>
          <md-icon class="sub-item-icon" v-else>{{ link.icon }}</md-icon>
          <span class="sidebar-normal">{{ link.name }}</span>
        </template>
        <template v-else>
          <template v-if="link.icon_type === 'fontawesome'">
            <i class="side-bar-fas" :class="`${link.icon}`"></i>
          </template>
          <template v-else>
            <md-icon>{{ link.icon }}</md-icon>
          </template>
          <p>{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  name: "sidebar-item",
  components: {
    CollapseTransition
  },
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: []
        };
      }
    }
  },
  provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true
    }
  },
  data() {
    return {
      children: [],
      collapsed: true
    };
  },
  computed: {
    baseComponent() {
      return this.isMenu || this.link.isRoute ? "li" : "router-link";
    },
    linkPrefix() {
      if (this.link.name) {
        let words = this.link.name.split(" ");
        return words.map(word => word.substring(0, 1)).join("");
      }
      return false;
    },
    isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive() {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find(c =>
          this.$route.path.startsWith(c.link.path)
        );
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild(item) {
      const index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild(item) {
      const tabs = this.children;
      const index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType(link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? "li" : "a";
      } else {
        return "router-link";
      }
    },
    linkAbbreviation(name) {
      const matches = name.match(/\b(\w)/g);
      return matches.join("");
    },
    linkClick() {
      // if (!this.addLink) {
      //   this.$sidebar.collapseAllMenus();
      // }

      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    collapseMenu() {
      if (this.collapsed) {
        this.$sidebar.addSidebarLink(this);
        // this.$sidebar.collapseAllMenus();
      }

      this.collapsed = !this.collapsed;
    },
    collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    // if (this.isActive && this.isMenu) {
    // this.collapsed = false;
    // }
    this.collapsed = false;
  },
  destroyed() {
    this.$sidebar.removeSidebarLink(this);
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
};
</script>
<style>
.sidebar .nav .sidebarMenuItem,
.sidebar .nav li.active .sidebarMenuItem,
.sidebar .nav li:hover .sidebarMenuItem,
.sidebar .nav li .sidebarMenuItemNoChild,
.sidebar .nav li.active .sidebarMenuItemNoChild {
  cursor: pointer;
  background-color: #43a047 !important; /* #00bcd4 !important;  */
  /* box-shadow: 0 12px 20px -10px rgba(0, 188, 212, 0.28), 
    0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(0, 188, 212, 0.2);*/
  color: #fff !important;
  /* background-color: #fe7835 !important;
  color: #665f56 !important; */
}
/* #66bb6a #43a047 */
.sidebar[data-color="azure"].mayai li.active > a:not([data-toggle="collapse"]) {
  box-shadow: 0 12px 20px -10px rgba(253, 109, 37, 0.5),
    0 4px 20px 0px rgba(0, 0, 0, 0.01), 0 7px 8px -5px rgba(253, 109, 37, 0.3) !important;
}

.sidebar .nav li .sidebarMenuItemNoChild i,
.sidebar .nav li:hover .sidebarMenuItemNoChild i,
.sidebar-menu-logo {
  color: #fff !important;
  opacity: 1 !important;
}

.sidebar .nav li .active .sidebarMenuSubItem {
  /* background-color:#a9afbb !important; */
  color: #fff !important;      /*   #3c4858 !important;*/
  font-weight: bold;
}

.sidebar .nav .sub-item-icon {
  font-size: 20px !important;
  color: #a9afbb !important;
  opacity: 0.8;
}

/* .sidebar .nav li.active .active .sub-item-icon {
  
  font-size: 20px !important;
  color: #a9afbb !important;
  opacity: 0.8;
} */
/* color: #3c4858 !important; */
/* .sidebar .nav .side-bar-fas-sub-item {
  color: #a9afbb !important;
  opacity: 0.8;
  font-size: 16px !important;
} */
/* .sidebar .nav .router-link-active .side-bar-fas-sub-item {
  color: #3c4858 !important;
  opacity: 1;
} */
</style>
